import { useState, useEffect } from "react";
import {
    Button,
    FormControl,
    Select,
    MenuItem,
    Typography,
    Box,
    Grid,
    useMediaQuery,
    CircularProgress,
    IconButton,
} from "@mui/material";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";



export default function PetFoundSearch() {
    const navigate = useNavigate();
    const { t, } = useTranslation();
    const isMobile = useMediaQuery("(max-width:900px)");

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const [formErrors, setFormErrors] = useState({});
    const [basicInfo, setBasicInfo] = useState({
        animal: "",
    });

    const Label = ({ children, htmlFor, className, ...props }) => (
        <Typography
            component="label"
            htmlFor={htmlFor}
            className={className}
            variant="body2"
            color="textPrimary"
            {...props}
        >
            {children}
        </Typography>
    );

    const [imagePreviews, setImagePreviews] = useState([]); // Array of preview URLs
    const [imageFiles, setImageFiles] = useState([]);       // Array of File objects

    const handleImageChange = (e) => {
        const files = Array.from(e.target.files);
        const newPreviews = [];
        const newFiles = [];

        files.forEach(file => {
            if (file && file.type.startsWith("image/")) {
                newFiles.push(file);
                const reader = new FileReader();
                reader.onloadend = () => {
                    setImagePreviews(prev => [...prev, reader.result]);
                };
                reader.readAsDataURL(file);
            }
        });

        setImageFiles(prev => [...prev, ...newFiles]);
        setBasicInfo({
            ...basicInfo,
            imageFiles: [...(basicInfo.imageFiles || []), ...newFiles], // Store all files for upload
        });
    };

    const handleRemoveImage = (idx) => {
        setImagePreviews(prev => prev.filter((_, i) => i !== idx));
        setImageFiles(prev => prev.filter((_, i) => i !== idx));
        setBasicInfo({
            ...basicInfo,
            imageFiles: imageFiles.filter((_, i) => i !== idx),
        });
    };

    const validateForm = () => {
        const errors = {};
        const newDateErrors = {};

        if (imagePreviews.length === 0) {
            errors.images = "請上傳至少一張圖片";
        }
        if (!basicInfo.animal) errors.animal = "請選擇物種";

        setFormErrors(errors);
        return (
            Object.keys(errors).length === 0
        );
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) {
            return;
        }

        navigate("/pet_search_page",{ state: {imageFiles, animal: basicInfo.animal}});

    };


    return (
        <Box
            sx={{ background: "#FCF8F3", minHeight: "100vh", pt: 15, position: "relative" }}
        >
            <Navbar />
            <Box sx={{ color: "black", minWidth: 0, position: "absolute", left: isMobile ? 10 : 80, display: 'flex', }}>
                <Button
                    sx={{ color: "black", minWidth: 0, }}
                    onClick={() => navigate("/all_lost_pets")}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="20" viewBox="0 0 14 24" fill="none">
                        <path d="M12 22L2 12L12 2" stroke="#050505" stroke-width="3.33333" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </Button>
                <Typography sx={{ ml: 1, fontSize: isMobile ? 26 : 34, fontWeight: 700 }}>{t('AIPetFounder')}</Typography>
            </Box>
            <Box sx={{ pt: 10, px: isMobile ? 2 : 10, }}>
                <Typography sx={{ fontSize: isMobile ? 16 : 20, px: 3, }}>{t('BeforeInt')}</Typography>
                <Box sx={{ mt: 6, mb: 2, px: 3, }}>
                    <Grid container spacing={isMobile ? 3 : 9}>
                        <Grid item xs={12} md={4}>
                            <Box sx={{ display: "flex", flexDirection: "column", gap: 3, minWidth: isMobile ? 310 : 400 }}>
                                <Box>
                                    <Label htmlFor="animal" sx={{ display: "block", mb: 1 }}>
                                        {t('Species')}
                                        {!basicInfo.animal && (
                                            <span style={{ color: "red", marginLeft: 4 }}>*</span>
                                        )}
                                    </Label>
                                    <FormControl fullWidth error={!!formErrors.animal}>
                                        <Select
                                            id="animal"
                                            name="animal"
                                            value={basicInfo.animal}
                                            onChange={(e) =>
                                                setBasicInfo({ ...basicInfo, animal: e.target.value })
                                            }
                                            displayEmpty
                                            sx={{
                                                backgroundColor: "white",
                                                "& .MuiOutlinedInput-root": {
                                                    backgroundColor: "white",
                                                },
                                            }}
                                            MenuProps={{
                                                disableScrollLock: true
                                            }}
                                        >
                                            <MenuItem value="" disabled>
                                                {t('PleaseSelect')}
                                            </MenuItem>
                                            <MenuItem value="狗">{t('dog')}</MenuItem>
                                            <MenuItem value="貓">{t('cat')}</MenuItem>
                                            <MenuItem value="兔">{t('Rabbit')}</MenuItem>
                                            <MenuItem value="龜">{t('Turtle')}</MenuItem>
                                            <MenuItem value="鳥">{t('Bird')}</MenuItem>
                                            <MenuItem value="蜥蜴">{t('Lizard')}</MenuItem>
                                            <MenuItem value="倉鼠">{t('Hamster')}</MenuItem>
                                            <MenuItem value="其他">{t('other')}</MenuItem>
                                        </Select>
                                        {formErrors.animal && (
                                            <Typography color="error" variant="caption" sx={{ mt: 1 }}>
                                                {formErrors.animal}
                                            </Typography>
                                        )}
                                    </FormControl>
                                </Box>
                                <Box sx={{ flexGrow: 1 }}>
                                    <Label sx={{ display: "block", mb: 1 }}>
                                        {t('Photos5')}
                                        {imagePreviews.length === 0 && (
                                            <span style={{ color: "red", marginLeft: 4 }}>*</span>
                                        )}
                                    </Label>

                                    <Box
                                        sx={{
                                            border: 1,
                                            borderColor: "grey.300",
                                            borderRadius: 1,
                                            p: 4,
                                            display: "flex",
                                            flexDirection: "row",
                                            flexWrap: "wrap",
                                            alignItems: imagePreviews.length > 0 ? "flex-start" : "center",
                                            justifyContent: imagePreviews.length > 0 ? "flex-start" : "center",
                                            gap: 2,
                                            minHeight: 300,
                                            width: isMobile ? 310 : 400,
                                            backgroundColor: "white",
                                            position: "relative",
                                        }}
                                    >
                                        {imagePreviews.length > 0 ? (
                                            imagePreviews.map((preview, idx) => (
                                                <Box key={idx} sx={{ position: "relative", }}>
                                                    <img
                                                        src={preview}
                                                        alt={`預覽圖片${idx + 1}`}
                                                        style={{
                                                            maxWidth: 100,
                                                            maxHeight: 100,
                                                            marginBottom: 8,
                                                            borderRadius: 8,
                                                            objectFit: "cover",
                                                        }}
                                                    />
                                                    <IconButton
                                                        size="small"
                                                        sx={{
                                                            position: "absolute",
                                                            top: -10,
                                                            right: -10,
                                                            background: "rgba(66, 66, 66, 0.7)",
                                                            zIndex: 2,
                                                        }}
                                                        onClick={() => handleRemoveImage(idx)}
                                                    >
                                                        <CloseIcon fontSize="small" fill="white" />
                                                    </IconButton>
                                                </Box>

                                            ))
                                        ) : (
                                            <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <rect width="25" height="25" rx="12.5" fill="#FFF0CD" />
                                                <path d="M12.5 8.33594V16.6693" stroke="#FFB60C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                <path d="M8.33203 12.5H16.6654" stroke="#FFB60C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                        )}
                                        {imagePreviews.length > 0 && imagePreviews.length < 5 && (<Box sx={{
                                            width: 100,
                                            height: 100,
                                            marginBottom: 8,
                                            borderRadius: 5,
                                            border: "2px dashed #C4C4C4",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                        }}>
                                            <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <rect width="25" height="25" rx="12.5" fill="#FFF0CD" />
                                                <path d="M12.5 8.33594V16.6693" stroke="#FFB60C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                <path d="M8.33203 12.5H16.6654" stroke="#FFB60C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                        </Box>)}
                                        {imagePreviews.length < 5 && (<input
                                            type="file"
                                            accept="image/*"
                                            multiple
                                            style={{
                                                position: "absolute",
                                                width: "100%",
                                                height: "100%",
                                                opacity: 0,
                                                left: 0,
                                                top: 0,
                                                cursor: "pointer",
                                            }}
                                            onChange={handleImageChange}
                                        />)}
                                    </Box>
                                    <Typography
                                        variant="body2"
                                        color="textSecondary"
                                        sx={{ mt: 1, textAlign: "left", width: isMobile ? 300 : 400 }}
                                    >
                                        {t('photoInfo')}

                                    </Typography>
                                    {formErrors.images && (
                                        <Typography color="error" variant="caption" sx={{ mt: 1 }}>
                                            {formErrors.images}
                                        </Typography>
                                    )}
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>

                {/* Bottom Buttons */}
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: isMobile ? "column" : "row",
                        justifyContent: { xs: "center", md: "flex-start" },
                        alignItems: isMobile ? "stretch" : "center",
                        my: 5,
                        mx: 3,
                        gap: 2,
                    }}
                >
                    <Button
                        type="submit"
                        variant="contained"
                        sx={{
                            backgroundColor: "#FFB60C",
                            color: "#050505",
                            minWidth: 120,
                            "&:hover": { backgroundColor: "#FFB60C" },
                            "&:disabled": { background: "rgba(255, 182, 12, 0.5)" },
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "10px",
                        }}
                        onClick={handleSubmit}
                    >
                        {t('Submit')}
                    </Button>
                </Box>

                <Typography
                    variant="h6"
                    sx={{ mt: 3, mb: 1, fontSize: 16, px: 3, pb: 2 }}
                >
                    {t('noPhoto')} <a style={{ textDecoration: "underline", color: "#65A8FB" }} href="/all_lost_pets">{t('ViewallLostPets')}</a>
                </Typography>

                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, alignItems: 'flex-start', px: 3 }}>
                    <Box fontWeight={700} fontSize={26} >{t('StepstoHandleFLPets')}</Box>
                    <Box fontWeight={700} >{t('Step1Header')}</Box>
                    <Box>{t('Step1')}</Box>
                    <Box fontWeight={700} >{t('Step2Header')}</Box>
                    <Box>{t('Step2')}</Box>
                    <Box fontWeight={700} >{t('Step3Header')}</Box>
                    <Box>{t('Step3')}</Box>
                    <Box fontWeight={700} >{t('Step4Header')}</Box>
                    <Box>{t('Step4')}</Box>
                    <Box fontWeight={700} >{t('Step5Header')}</Box>
                    <Box>{t('Step5')}</Box>
                    <Box fontWeight={700} >{t('Step6Header')}</Box>
                    <Box>{t('Step6')}</Box>
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, alignItems: 'flex-start', px: 3, my: 3 }}>
                    <Box fontWeight={700} fontSize={26} >{t('FAQ')}</Box>
                    <Box fontWeight={700} >{t('FAQ1Q')}</Box>
                    <Box>{t('FAQ1Qans')}</Box>
                    <Box fontWeight={700} >{t('FAQ2Q')}</Box>
                    <Box>{t('FAQ2Qans')}</Box>
                    <Box fontWeight={700} >{t('FAQ3Q')}</Box>
                    <Box>{t('FAQ3Qans')}</Box>
                    <Box fontWeight={700} >{t('FAQ4Q')}</Box>
                    <Box>{t('FAQ4Qans')}</Box>
                </Box>
            </Box>
            <Footer />
        </Box>
    );
}
